import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { URL } from "../../../../constant";
import { useLearningHistory } from "../../../../hooks";
import { birthYearsLevel } from "../../../../utils/utilityEtc";
import XbtnTitleHeader from "../../../common/header/XbtnTitleHeader";

const DiagnosisGuide3 = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { onLearningExitBtn } = useLearningHistory();

  const [selectedLevel, setSelectedLevel] = useState(location?.state?.selectedLevel || null);
  const [year, setYear] = useState([]);

  const onClick = (event) => {
    event.preventDefault();
    
    const selectedLevel = event?.currentTarget?.dataset?.level;
    setSelectedLevel(selectedLevel);
    
    // setSelectedLevel(prev => {
    //   // 중복 클릭 시 'on' 클래스 제거 > 선택안함 적용
    //   if(prev === selectedLevel) return null;
    //   return selectedLevel;
    // });
  };

  const goExitPage = useCallback(() => {
    onLearningExitBtn();
  });

  const goBackPage = useCallback(() => {
    if(location.pathname === URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DiagnosisGuide3) {
      history.replace(`${URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DiagnosisGuide2}`);
    } else {
      history.goBack();
    }
  });

  const goNextPage = useCallback(() => {
    history.push({
      pathname : `${URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION}`,
      state : {
        selectedLevel : selectedLevel,
      }
    });
  });

  useEffect(() => {
    if(_.isNull(selectedLevel) && year[0]?.data) setSelectedLevel(year[0]?.data);
  }, [year]);

  useEffect(() => {
    if (year.length === 0) {
      setYear(birthYearsLevel('levelSelection'));
    }
  }, []);

  return (
    <div className="layout-def layout-lc">
      <XbtnTitleHeader title={t("LC_02_03.msg001")} onClose={goExitPage} />
      <div className="  container">
        <div className="inner">
          <div className="centermiddleBox">
            <div className="centermiddleBox-row">
              <div className={`dsc_cont3 ${getlanClass()}`}>
                <div className="aic-intro2">
                  <div className="aic-intro-item">
                    <h2 className="tit">{t("LC_02_03.msg003")}</h2>
                  </div>
                  <ul className="level_lst">
                    {
                      year.slice(0, -1).map((item, itemIndex) => {
                        const { subText, data} = item;
                        
                        return (
                          <li key={subText} className={`level_${item.subText.toLowerCase()}${getOnClass(data, selectedLevel)}`} data-level={data} onClick={onClick}>
                          <a className="#none">
                            <strong className="level">{subText}</strong>
                            <p
                              className="sub_txt"
                              dangerouslySetInnerHTML={{
                                __html: t(`LC_02_03.msg00${itemIndex + 4}`),
                              }}
                            />
                          </a>
                        </li>
                        );
                      })
                    }
                    {/* li element 참고 */}
                    {/* <li className={`level_b ${getOnClass(1, selectedLevel)}`} data-index="1" onClick={onClick}>
                      <a href="#none">
                        <strong className="level">B</strong>
                        <p
                          className="sub_txt"
                          dangerouslySetInnerHTML={{
                            __html: t("LC_02_03.msg005"),
                          }}
                        />
                      </a>
                    </li>*/}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-inner">
          <div className="d-flex">
            <div className="d-item">
              <button
                className={`btn-small btn-gray btn-left ${getlanClass()}`}
                onClick={goBackPage}
              >
                <span className="m-txt">{t("LC_02_03.msg008")}</span>
              </button>
            </div>
            <div className="d-item btnItem-auto">
              <button
                className={`btn btn-blue ${getlanClass()}`}
                onClick={goNextPage}
              >
                {t("LC_02_03.msg009")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiagnosisGuide3;

const getlanClass = () => {
  const { i18n } = useTranslation();
  return _.isEqual(i18n.language, "ko") ? "ko" : "en";
};

const getOnClass = (data, selectedLevel) => {
  return !_.isNull(selectedLevel) && _.isEqual(Number(data), Number(selectedLevel)) ? " on" : "";
}
